// extracted by mini-css-extract-plugin
export default {"dialog":"modal-module___dialog___ef9b71d3","in":"modal-module___in___e916f083","wrapper":"modal-module___wrapper___cb347eb5"};